import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { Vehicle } from '@classes/vehicles/vehicle';
import { VehiclesService } from '@services/vehicles/vehicles.service';
import { ProductTypesService } from "@services/productTypes.service";
import { ProductType } from "@classes/productType";


@Injectable()
export class ProductTypesResolver {
    constructor(
        private productTypesSrv: ProductTypesService,
        private uiSrv: UiService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProductType[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.productTypesSrv.getList()
            .pipe(
                tap(() => {
                    this.uiSrv.routeLoadingStateChanged.next(false);
                })
            );
    }
}
